import CheckboxCustom from '@material-ui/core/Checkbox'
import styled from 'styled-components'

const Checkbox = styled(CheckboxCustom)``

export default Checkbox
